module.exports = __webpack_public_path__ + "static/SphereViewCarousel-66c082ce0504baa3a86494acda4c987d.png";